import { render, staticRenderFns } from "./planetary-activations.vue?vue&type=template&id=8be18c16&"
import script from "./planetary-activations.vue?vue&type=script&lang=js&"
export * from "./planetary-activations.vue?vue&type=script&lang=js&"
import style0 from "./planetary-activations.vue?vue&type=style&index=0&id=8be18c16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports